import { getStaticAsset } from "core/model/config";
import { useMedia } from "dsl/atoms/ResponsiveMedia";
import { useOnEnter } from "dsl/atoms/Routes";
import { useB2CNavigationHandlers } from "dsl/hooks/useNavigationHandlers";
import {
  B2CFilterActions,
  B2CFilters,
} from "dsl/organisms/Filters/B2CApp/types";
import { useParams } from "react-router-dom";
import { useTranslations } from "translations";
import { useB2CHeaderContext } from "../B2CDashboard/B2CHeader";
import CareSolution, { CareSolutionBackground } from "./Pages/CareSolution";
import CareType from "./Pages/CareType";
import DailyLivingSupportServices from "./Pages/DailyLivingSupportService";
import Loading from "./Pages/Loading";
import Location from "./Pages/Location";
import StartDate from "./Pages/StartDate";
import Target from "./Pages/Target";
import Term from "./Pages/Term";
import Welcome from "./Pages/Welcome";
import Stepper from "./Stepper";
import { BackgroundImage, StepperPage } from "./common";
import { B2C_ONBOARDING_PAGES } from "core/consts";
import { B2COnboardingPage } from "core/types";

export const DEFAULT_ONBOARDING_PAGE = "welcome";

export type B2COnboardingProps = {
  filters: B2CFilters;
  setFilters: React.Dispatch<B2CFilterActions>;
};

export default function B2COnboarding() {
  const { filters, setFilters } = useB2CHeaderContext();
  const { page = DEFAULT_ONBOARDING_PAGE } = useParams<{
    page: B2COnboardingPage;
  }>();
  useOnEnter();
  const { goToOnboarding } = useB2CNavigationHandlers();

  const translations = useTranslations();
  const { isDesktop } = useMedia();

  const navigateToPage = (page: B2COnboardingPage) => goToOnboarding({ page });

  const PagesToJSX = {
    [B2C_ONBOARDING_PAGES.CARE_SOLUTION]: CareSolution,
    [B2C_ONBOARDING_PAGES.CARE_TERM]: Term,
    [B2C_ONBOARDING_PAGES.CARE_TYPE]: CareType,
    [B2C_ONBOARDING_PAGES.DAILY_LIVING_SUPPORT_SERVICES]:
      DailyLivingSupportServices,
    [B2C_ONBOARDING_PAGES.LOADING]: Loading,
    [B2C_ONBOARDING_PAGES.LOCATION]: Location,
    [B2C_ONBOARDING_PAGES.START_DATE]: StartDate,
    [B2C_ONBOARDING_PAGES.TARGET]: Target,
    [B2C_ONBOARDING_PAGES.WELCOME]: Welcome,
  };

  const ActivePage = PagesToJSX[page];

  const background =
    page !== B2C_ONBOARDING_PAGES.CARE_SOLUTION ? (
      <BackgroundImage image={getStaticAsset("b2c_onboarding_image.png")} />
    ) : (
      <CareSolutionBackground />
    );
  const showBackground =
    page === B2C_ONBOARDING_PAGES.CARE_SOLUTION || isDesktop;

  return (
    <StepperPage
      background={background}
      showBackground={showBackground}
      stepper={<Stepper activePage={page} />}
    >
      <ActivePage
        filters={filters}
        navigateToPage={navigateToPage}
        setFilters={setFilters}
        translations={translations}
      />
    </StepperPage>
  );
}
